
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 69.542 69.542"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Google_Contacts_icon"}},[_c('circle',{attrs:{"id":"Ellipse_175","data-name":"Ellipse 175","fill":"#1972e6","cx":"34.771","cy":"34.771","r":"34.771"}}),_c('g',{attrs:{"id":"Group_8245","data-name":"Group 8245","transform":"translate(18.388 16.533)"}},[_c('g',{attrs:{"id":"Group_8243","data-name":"Group 8243","transform":"translate(0 1.945)","fill":"#1759bb"}},[_c('path',{attrs:{"id":"Path_1322","data-name":"Path 1322","d":"M155.965 266v-2.947a4.349 4.349 0 00-1.017-2.8 15.024 15.024 0 00-2.05-2.08c-2.843-2.155-7-3.531-11.895-3.935a17 17 0 00-4.264.075c-5.865.673-10.354 2.708-12.688 5.745-.09.12-.18.224-.254.329a4.353 4.353 0 00-.9 2.648v2.977a4.578 4.578 0 004.578 4.578H151.4a4.617 4.617 0 004.565-4.59z","transform":"translate(-122.9 -234.59)"}}),_c('circle',{attrs:{"id":"Ellipse_176","data-name":"Ellipse 176","cx":"7.63","cy":"7.63","r":"7.63","transform":"translate(8.753)"}})]),_c('g',{attrs:{"id":"Group_8244","data-name":"Group 8244","fill":"#fff"}},[_c('path',{attrs:{"id":"Path_1323","data-name":"Path 1323","d":"M155.965 253v-2.947a4.349 4.349 0 00-1.017-2.8 15.022 15.022 0 00-2.05-2.08c-2.843-2.154-7-3.531-11.895-3.935a17 17 0 00-4.264.075c-5.865.673-10.354 2.708-12.688 5.745-.09.12-.18.224-.254.329a4.353 4.353 0 00-.9 2.648v2.977a4.578 4.578 0 004.578 4.578H151.4a4.6 4.6 0 004.565-4.59z","transform":"translate(-122.9 -221.59)"}}),_c('circle',{attrs:{"id":"Ellipse_177","data-name":"Ellipse 177","cx":"7.63","cy":"7.63","r":"7.63","transform":"translate(8.753)"}})])])])])
          )
        }
      }
    